<div class="floori-arrows-container">
    <div class="row" [ngClass]="{ 'mosaics-row': isMosaicsStyle() }">
        <button
            [class]="buttonClass()"
            (mousedown)="handleButtonHold(step(), transitionType.y, $event)"
            [flooriTooltip]="showTooltips() ? values().y.toString() : ''"
            [tooltipDirection]="popupDirection.above"
            [disableArrow]="true"
            [disableTranslation]="true"
            [disabled]="disabled()">
            <floori-icon [name]="iconName()" [class]="iconRotation()"></floori-icon>
        </button>
    </div>
    <div class="row" [ngClass]="{ 'mosaics-row': isMosaicsStyle() }">
        <button
            [class]="buttonClass() + ' rotate-270'"
            (mousedown)="handleButtonHold(-step(), transitionType.x, $event)"
            [flooriTooltip]="showTooltips() ? values().x.toString() : ''"
            [tooltipDirection]="popupDirection.above"
            [disableArrow]="true"
            [disableTranslation]="true"
            [disabled]="disabled()">
            <floori-icon [name]="iconName()" [class]="iconRotation()"></floori-icon>
        </button>
        @if(showMiddleIcon()) {
        <button floori-icon-button class="outline" disabled>
            <floori-icon [name]="middleButtonIcon()"></floori-icon>
        </button>
        } @else {
        <div class="center-dot" [ngClass]="{ mosaics: isMosaicsStyle() }"></div>
        }
        <button
            [class]="buttonClass() + ' rotate-90'"
            (mousedown)="handleButtonHold(step(), transitionType.x, $event)"
            [flooriTooltip]="showTooltips() ? values().x.toString() : ''"
            [tooltipDirection]="popupDirection.above"
            [disableArrow]="true"
            [disableTranslation]="true"
            [disabled]="disabled()">
            <floori-icon [name]="iconName()" [class]="iconRotation()"></floori-icon>
        </button>
    </div>
    <div class="row" [ngClass]="{ 'mosaics-row': isMosaicsStyle() }">
        <button
            [class]="buttonClass() + ' rotate-180'"
            (mousedown)="handleButtonHold(-step(), transitionType.y, $event)"
            [flooriTooltip]="showTooltips() ? values().y.toString() : ''"
            [tooltipDirection]="popupDirection.above"
            [disableArrow]="true"
            [disableTranslation]="true"
            [disabled]="disabled()">
            <floori-icon [name]="iconName()" [class]="iconRotation()"></floori-icon>
        </button>
    </div>
</div>
